var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtnAdmsetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_setting",
    transform: "translate(-5.893 0.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 24,
    height: 24,
    transform: "translate(5.893 -0.359)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712",
    transform: "translate(-0.643 -0.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M-1.56-10.768a2.681,2.681,0,0,1-2-.882,2.543,2.543,0,0,1-.632-2.058,9.392,9.392,0,0,1,1.819-4.633A6.186,6.186,0,0,1,.015-20.174a4.249,4.249,0,0,1-1.553-3.281A4.229,4.229,0,0,1-.166-26.582a4.485,4.485,0,0,1,3.277-1.194A4.4,4.4,0,0,1,7.348-23.6,4.291,4.291,0,0,1,5.8-20.18a6.154,6.154,0,0,1,1.535.949.492.492,0,0,1,.051.707.525.525,0,0,1-.727.05,5.254,5.254,0,0,0-2.131-1.078.506.506,0,0,1-.384-.432.5.5,0,0,1,.283-.5,3.322,3.322,0,0,0,1.89-3.082,3.377,3.377,0,0,0-3.253-3.206,3.439,3.439,0,0,0-2.518.917,3.248,3.248,0,0,0-1.053,2.4,3.3,3.3,0,0,0,1.9,2.972.5.5,0,0,1,.283.5.505.505,0,0,1-.383.433c-2.452.619-3.993,2.687-4.459,5.978a1.558,1.558,0,0,0,.387,1.262,1.637,1.637,0,0,0,1.22.539h0l4.6,0h0a.509.509,0,0,1,.516.5.508.508,0,0,1-.515.5l-4.6,0Z",
    transform: "translate(14.749 30.809)",
    fill: "#6db3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M-3.376-8.439a.418.418,0,0,1-.408-.331l-.172-.815a3.439,3.439,0,0,1-.879-.51l-.795.261a.417.417,0,0,1-.491-.188l-.7-1.214a.416.416,0,0,1,.082-.519l.621-.558a3.45,3.45,0,0,1-.039-.509,3.446,3.446,0,0,1,.038-.508l-.622-.556a.417.417,0,0,1-.083-.519l.7-1.215a.416.416,0,0,1,.49-.189l.8.259a3.441,3.441,0,0,1,.878-.512l.171-.815a.417.417,0,0,1,.408-.331l1.4,0h0a.417.417,0,0,1,.408.331l.172.815a3.424,3.424,0,0,1,.879.51l.8-.261a.417.417,0,0,1,.491.188l.7,1.214a.417.417,0,0,1-.083.519l-.621.558a3.438,3.438,0,0,1,.039.508h0a3.436,3.436,0,0,1-.038.508l.622.556a.417.417,0,0,1,.083.519l-.7,1.215a.416.416,0,0,1-.49.189l-.8-.259a3.432,3.432,0,0,1-.878.512l-.171.815a.417.417,0,0,1-.408.331l-1.4,0ZM-4.743-10.98a.417.417,0,0,1,.281.109,2.616,2.616,0,0,0,.99.574.416.416,0,0,1,.283.311l.151.712h.726l.149-.712A.418.418,0,0,1-1.88-10.3a2.621,2.621,0,0,0,.988-.576.416.416,0,0,1,.411-.089l.7.227.362-.629-.544-.487a.416.416,0,0,1-.129-.4,2.643,2.643,0,0,0,.063-.573A2.647,2.647,0,0,0-.1-13.4a.418.418,0,0,1,.128-.4l.543-.488-.364-.628-.7.228A.417.417,0,0,1-.9-14.775a2.616,2.616,0,0,0-.99-.574.416.416,0,0,1-.283-.311l-.151-.712h-.726l-.149.712a.418.418,0,0,1-.283.312,2.614,2.614,0,0,0-.988.576.416.416,0,0,1-.411.089l-.7-.227-.362.629.544.487a.417.417,0,0,1,.129.4,2.644,2.644,0,0,0-.064.573,2.647,2.647,0,0,0,.065.573.418.418,0,0,1-.128.4l-.543.488.363.628.7-.228a.406.406,0,0,1,.13-.021",
    transform: "translate(24.897 29.584)",
    fill: "#6db3e0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAdmsetting);
export default __webpack_public_path__ + "static/media/btn_admsetting.681a94fd45227a7edf45cb674a17d888.svg";
export { ForwardRef as ReactComponent };